
import React, { use, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaLightbulb,
  FaImage,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hitGetServiceProfessionalApi } from "../../../Redux/Professional/GetServiceSlice";
import { hitSavePromotionProfessionalAPi } from "../../../Redux/Professional/SavePromotionSlice";
import { showToast } from "../../../Helper/Toast";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import { hitGetServiceAreaApi } from "../../../Redux/Professional/GetServiceAreasListProSlice";
import galleryIcon from "../../../assets/img/gallery icon.svg";
import CampaignTips from "../../../assets/img/Campaign Tips.svg";
import success from "../../../assets/img/success green icon.svg";
import Loader from "../../Loader/Loader";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { set } from "date-fns";

const AddPromotion = () => {
  const navigate = useNavigate();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [servicesData, setServicesData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [imagesResponse, setImagesResponse] = useState([]);
  const [staticServiceAreas, setStaticServiceAreas] = useState([]);

  const [selectedServiceAreas, setSelectedServiceAreas] = useState([]);

  const [loading, setLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    serviceId: "",
    serviceAreaIds: [],
    discountType: "",
    discountValue: 0,
    originalValue: 0,
    duration: 5,
  });

  const durationOptions = [
    { value: "1", label: "1 day", credits: 5 },
    { value: "2", label: "2 days", credits: 10 },
    { value: "3", label: "3 days", credits: 15 },
    { value: "4", label: "4 days", credits: 20 },
    { value: "5", label: "5 days", credits: 25 },
    { value: "6", label: "6 days", credits: 30 },
    { value: "7", label: "7 days", credits: 21 },
    { value: "8", label: "8 days", credits: 24 },
    { value: "9", label: "9 days", credits: 27 },
    { value: "10", label: "10 days", credits: 30 },
    { value: "11", label: "11 days", credits: 33 },
    { value: "12", label: "12 days", credits: 36 },
    { value: "13", label: "13 days", credits: 39 },
    { value: "14", label: "14 days", credits: 28 },
    { value: "15", label: "15 days", credits: 30 },
    { value: "16", label: "16 days", credits: 32 },
    { value: "17", label: "17 days", credits: 34 },
    { value: "18", label: "18 days", credits: 36 },
    { value: "19", label: "19 days", credits: 38 },
    { value: "20", label: "20 days", credits: 40 },
    { value: "21", label: "21 days", credits: 42 },
    { value: "22", label: "22 days", credits: 44 },
    { value: "23", label: "23 days", credits: 46 },
    { value: "24", label: "24 days", credits: 48 },
    { value: "25", label: "25 days", credits: 50 },
    { value: "26", label: "26 days", credits: 52 },
    { value: "27", label: "27 days", credits: 54 },
    { value: "28", label: "28 days", credits: 56 },
    { value: "29", label: "29 days", credits: 58 },
    { value: "30", label: "30 days", credits: 60 },
  ];

  const pricingTiers = [
    {
      name: "Short Burst (1-6 days)",
      description: "5 credits /day",
      type: "short",
    },
    {
      name: "Steady Exposure (7-13 days)",
      description: "3 credits /day",
      type: "steady",
    },
    {
      name: "Max Reach (14-30 days)",
      description: "2 credits /day",
      type: "max",
    },
  ];
  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      dispatch(hitGetServiceProfessionalApi());
    }
  }, []);

  const responseServicesData = useSelector(
    (state) => state.getServiceProfessionalReducer.data
  );


  useEffect(() => {
    const fetchData = async () => {
      if (responseServicesData?.status === true) {
        setServicesData(responseServicesData?.data || []);
        getCreditsForDuration();
        const serviceAreasResponse = await dispatch(hitGetServiceAreaApi(localStorage.getItem("professionalToken")));
        setStaticServiceAreas(serviceAreasResponse?.payload?.data || []);
      }
    };
    fetchData();
  }, [responseServicesData]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategorySelect = (serviceId) => {
    setFormData((prev) => ({
      ...prev,
      serviceId,
    }));
  };


  const handleNextStep = () => {
    if (
      formData.title.trim() === "" ||
      formData.serviceId === "" ||
      formData.serviceAreaIds.length === 0 ||
      (formData.description.trim() === "" && currentStep === 1)
    ) {
      showToast("Please enter all the fields", "error");
      return;
    }
    if (currentStep === 2) {
      if (imagesResponse.length === 0) {
        showToast("Please upload at least one image", "error");
        return;
      }
      if (formData.discountType === "1") {
        if (formData.originalValue === 0 || formData.discountValue === 0) {
          showToast("Please enter all the fields", "error");
          return;
        }
        if (
          parseFloat(formData.discountValue) >=
          parseFloat(formData.originalValue)
        ) {
          showToast("Amount Off should be less than Original Price", "error");
          return;
        }
      }
      if (formData.discountType === "2") {
        if (formData.discountValue === 0) {
          showToast("Please enter all the fields", "error");
          return;
        }
        if (parseFloat(formData.discountValue) > 100) {
          showToast(
            "Percentage Off should be less than or equal to 100",
            "error"
          );
          return;
        }
      }
      if (formData.discountType === "3") {
        if (formData.discountValue === 0) {
          showToast("Please enter all the fields", "error");
          return;
        }
      }
    }

    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate(-1); // 👈 Goes to previous page
    }
  };

  const handlePreview = () => {
    //console.log("Preview campaign:", formData);
  };

  const handleSavePromotion = () => {
    //console.log("Save promotion:", formData);
    setLoading(true);

    const objForSave = {
      promotionTitle: formData.title,
      promotionDetails: formData.description,
      serviceIds: formData.serviceId,
      serviceAreaIds: formData.serviceAreaIds,
      media: imagesResponse.map((img) => img.url),
      numberOfDays: formData.duration,
      creditPoints: getCreditsForDuration(),
      totalCreditSpent: getCreditsForDuration(),
      discountType: formData.discountType,
      discountValue: formData.discountValue,
      originalValue: formData.originalValue,
    };

    console.log("Object to save:", objForSave);

    dispatch(hitSavePromotionProfessionalAPi(objForSave)).then((response) => {
      //console.log("Save promotion response:", response);
      if (response?.payload?.status === true) {       
        showToast("Campaign saved successfully", "success");
         setLoading(false);
        navigate("/professional/campaigns");
      } else {
        setLoading(false);
        showToast(response.error.message, "error");
      }
      
    });
  };

  const getStepProgress = () => {
    return (currentStep / 3) * 100;
  };

  const getCreditsForDuration = () => {
    const selected = durationOptions.find(
      (opt) => opt.value === formData.duration
    );
    return selected ? selected.credits : 25;
  };


  // Remove image handler
  const handleRemoveImage = (removeIndex) => {
    setImagesResponse(prev => prev.filter((_, idx) => idx !== removeIndex));
    setUploadedFiles(prev => prev.filter((_, idx) => idx !== removeIndex));
  };


  // Handle file selection
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const newFiles = [...uploadedFiles, ...files];
    setUploadedFiles(newFiles);
    if (files.length > 0) {
      uploadFile(newFiles);
    }
  };


  // Function to handle file upload
  const uploadFile = async (filesToUpload) => {
    if (filesToUpload && filesToUpload.length > 0) {
      setLoading(true);
      const formDataMedia = new FormData();
      filesToUpload.forEach((file) => {
        formDataMedia.append("myfile", file);
      });
      try {
        const response = await dispatch(hitUploadMedia(formDataMedia));
        setLoading(false);
        if (response.payload.status === true) {
          showToast("Media uploaded successfully", "success");
          setImagesResponse(response.payload.data);
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
        setLoading(false);
      }
    }
  };

  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }
  return (
    <div className="add-promotion pro-app-page pro-app-page--muted">
      <div className="custom_container">
        <Row>
          <Col xl={8} className="main-content p-3">
            {/* Header */}
            <div className="promotion-header">
              <button className="back-btn" onClick={() => handlePreviousStep()}>
                <FaArrowLeft />
              </button>
              <div className="header-content">
                <h1>Create New Promotion</h1>
                <p>Step {currentStep} of 3</p>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="progress-bar-wrapper">
              <div
                className="progress-bar-fill"
                style={{ width: `${getStepProgress()}%` }}
              ></div>
            </div>

            {/* Step 1: Campaign Details */}
            {currentStep === 1 && (
              <div className="form-step">
                <div className="step-header text-center">
                  <h2>Create New Promotion</h2>
                  <p>Set up your promotional campaign details</p>
                </div>

                <div className="form-group">
                  <label>
                    Promotion Title <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="e.g. Enjoy 12 months free when booking"
                    className="form-input"
                  />
                  <small className="form-hint">
                    Provide a catchy title for the promotion
                  </small>
                </div>

                <div className="form-group">
                  <label>
                    Promotion Description <span className="required">*</span>
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Include information about the promotion to attract users"
                    className="form-textarea"
                    rows="5"
                  ></textarea>
                  <small className="form-hint">
                    Describe what makes this promotion special
                  </small>
                </div>

                <div className="form-group">
                  <label>
                    Service Area <span className="required">*</span>
                  </label>
                  <small className="form-hint">
                    Select one or more service areas for this promotion
                  </small>
                  {/* Show selected areas as chips */}

                  <ul style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    maxWidth: 400,
                    width: '100%'
                  }}>
                    {staticServiceAreas.map((area) => (
                      <li key={area._id} style={{
                        marginBottom: 12,
                        border: '1px solid #e0e0e0',
                        borderRadius: 8,
                        background: '#fafbfc',
                        transition: 'box-shadow 0.2s',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 14px',
                        cursor: 'pointer',
                        minHeight: 44
                      }}>
                        <label style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          cursor: 'pointer',
                          fontSize: 16,
                          gap: 12,
                          margin: 0
                        }}>
                          <input
                            type="checkbox"
                            value={area._id}
                            checked={formData.serviceAreaIds.includes(area._id)}
                            onChange={e => {
                              const checked = e.target.checked;
                              setFormData(prev => {
                                let updated;
                                if (checked) {
                                  updated = [...prev.serviceAreaIds, area._id];
                                } else {
                                  updated = prev.serviceAreaIds.filter(id => id !== area._id);
                                }
                                return { ...prev, serviceAreaIds: updated };
                              });
                            }}
                            style={{
                              width: 20,
                              height: 20,
                              accentColor: '#1976d2',
                              marginRight: 10,
                              flexShrink: 0
                            }}
                          />
                          <span style={{ flex: 1 }}>{area.address}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                  {/* Responsive styles */}
                  <style>{`
                    @media (max-width: 600px) {
                      .form-group ul {
                        max-width: 100% !important;
                        padding: 0 2vw !important;
                      }
                      .form-group li {
                        min-height: 48px !important;
                        font-size: 15px !important;
                        padding: 10px 6px !important;
                      }
                    }
                  `}</style>
                </div>

                <div className="form-group">
                  <label>
                    Select Category <span className="required">*</span>
                  </label>
                  <small className="form-hint">
                    Choose a category that best fits the promotion
                  </small>
                  <div className="category-grid">
                    {servicesData && servicesData.length > 0 ? (
                      servicesData.map((service) => (
                        <button
                          key={service._id}
                          className={`category-btn ${formData.serviceId === service._id ? "selected" : ""
                            }`}
                          onClick={() => handleCategorySelect(service._id)}
                        >
                          {service.name}
                        </button>
                      ))
                    ) : (
                      <p>No services available</p>
                    )}
                  </div>
                </div>

                <button className="next-step-btn" onClick={handleNextStep}>
                  Next Step
                </button>
              </div>
            )}

            {/* Step 2: Media & Pricing */}
            {currentStep === 2 && (
              <div className="form-step">
                <div className="step-header text-center">
                  <h2>Upload Images for Promotion</h2>
                  <p>
                    You can upload multiple images | File Accepted: jpg, png
                  </p>
                </div>

                <div className="upload-section">
                  <div className="upload-area">
                    <img
                      src={galleryIcon}
                      alt="galleryIcon"
                      className="upload-icon"
                    />
                    <p>Upload Images for Promotion</p>
                    <input
                      type="file"
                      id="file-upload"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleFileSelect}
                      style={{ display: "none" }}
                    />
                    <button
                      className="select-file-btn"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                    >
                      Select a File
                    </button>
                    {imagesResponse && imagesResponse.length > 0 && (
                      <div className="file-list mt-2" style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                        {imagesResponse.map((file, index) => (
                          <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                            <img
                              src={file.url}
                              alt={file.name || `file-${index}`}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: 8,
                                border: '1px solid #eee',
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveImage(index)}
                              style={{
                                position: 'absolute',
                                top: 2,
                                right: 2,
                                background: 'rgba(0,0,0,0.6)',
                                border: 'none',
                                borderRadius: '50%',
                                width: 24,
                                height: 24,
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                              }}
                              aria-label="Remove image"
                            >
                              <span style={{ fontSize: 18, lineHeight: 1 }}>&times;</span>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                  </div>
                </div>

                <div className="pricing-section">
                  <div className="pricing-header">
                    <h3>Pricing Information</h3>
                    <p>
                      Set your discount as amount off per sqft, amount off total
                      job, or percentage off total job.
                    </p>
                  </div>

                  <div className="form-group">
                    <label>
                      Discount Type
                    </label>
                    <div className="radio-group">
                      <Row>
                        <Col md={6}>
                          <label className="radio-label radio-label-2">
                            <input
                              type="radio"
                              name="discountType"
                              value="1"
                              checked={formData.discountType === "1"}
                              onChange={handleInputChange}
                            />
                            <div>
                              <span>Amount Off Per sqft</span>
                              <small>eg., $5 off per sqft</small>{" "}
                            </div>
                          </label>
                        </Col>
                        <Col md={6}>
                          <label className="radio-label radio-label-2">
                            <input
                              type="radio"
                              name="discountType"
                              value="2"
                              checked={formData.discountType === "2"}
                              onChange={handleInputChange}
                            />{" "}
                            <div>
                              <span>Percentage Off</span>

                              <small>eg., 20% off total project cost</small>
                            </div>
                          </label>
                        </Col>
                        <Col md={6}>
                          <label className="radio-label radio-label-2">
                            <input
                              type="radio"
                              name="discountType"
                              value="3"
                              checked={formData.discountType === "3"}
                              onChange={handleInputChange}
                            />
                            <div>
                              <span>Amount Off Total Job</span>
                              <small>eg., $100 off entire project</small>
                            </div>
                          </label>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  {formData.discountType === "1" && (
                    <div className="price-inputs">
                      <div className="form-group">
                        <label style={{ fontWeight: "bold" }}>
                          Original Price Per sqft ($)
                        </label>
                        <input
                          type="number"
                          name="originalValue"
                          value={formData.originalValue}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label style={{ fontWeight: "bold" }}>
                          Amount Off Per sqft ($)
                        </label>
                        <input
                          type="number"
                          name="discountValue"
                          value={formData.discountValue}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                    </div>
                  )}

                  {formData.discountType === "2" && (
                    <div className="form-group">
                      <label>Percentage Off (%)</label>
                      <input
                        type="number"
                        name="discountValue"
                        value={formData.discountValue}
                        onChange={handleInputChange}
                        className="form-input"
                        max="100"
                      />
                    </div>
                  )}

                  {formData.discountType === "3" && (
                    <div className="form-group">
                      <label>Amount Off Total Job ($)</label>
                      <input
                        type="number"
                        name="discountValue"
                        value={formData.discountValue}
                        onChange={handleInputChange}
                        className="form-input"
                        max="100"
                      />
                    </div>
                  )}
                </div>

                <div className="step-actions">
                  <button className="previous-btn" onClick={handlePreviousStep}>
                    Previous
                  </button>
                  <button className="next-step-btn" onClick={handleNextStep}>
                    Next Step
                  </button>
                </div>
              </div>
            )}

            {/* Step 3: Launch Settings */}
            {currentStep === 3 && (
              <div className="form-step">
                <div className="step-header">
                  <h2>Campaign Duration & Pricing</h2>
                  <p>How many days would you like your campaign to run?</p>
                </div>

                <div className="smart-pricing-section">
                  <div className="smart-pricing-header">
                    <FaLightbulb />
                    <span>Smart Pricing for Promotion Campaigns</span>
                  </div>
                  <div className="pricing-tiers">
                    {pricingTiers.map((tier) => (
                      <div key={tier.type} className="pricing-tier">
                        <span className="tier-dot">●</span>
                        <div className="tier-content">
                          <strong>{tier.name}</strong>
                          <p>{tier.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <p className="deactivate-note">
                    Deactivate anytime. You're only charged for the days your
                    promotion runs.
                  </p>
                </div>

                <div className="form-group">
                  <label>Campaign Duration</label>
                  <select
                    name="duration"
                    value={formData.duration}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {durationOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="campaign-summary">
                  <div className="campaign-summary-1">
                    <div className="summary-content">
                      <h4>Campaign Summary</h4>
                    </div>
                    <div className="summary-cost">
                      <h3>{getCreditsForDuration()} Credits</h3>
                      <p>Total Cost</p>
                    </div>
                  </div>
                  <div className="summary-row">
                    <span>Duration:</span>
                    <span>{formData.duration} days</span>
                  </div>
                </div>

                <div className="step-actions">
                  <button className="previous-btn" onClick={handlePreviousStep}>
                    Previous
                  </button>
                  {/* <button className="preview-btn mb-3" onClick={handlePreview}>
                    Preview
                  </button> */}
                  <button
                    className="preview-btn save-promotion-btn"
                    onClick={handleSavePromotion}
                  >
                    Save Promotion
                  </button>
                </div>

                {/* <button
                  className="save-promotion-btn"
                  onClick={handleSavePromotion}
                >
                  Save Promotion
                </button> */}
              </div>
            )}
          </Col>

          {/* Right Sidebar */}
          <Col xl={4}>
            <div className="sidebar-wrapper">
              {/* Progress Card */}
              <div className="progress-card">
                <h4>Campaign Setup Progress</h4>
                <div className="progress-steps">
                  <div
                    className={`progress-step ${currentStep >= 1 ? "completed" : ""
                      } ${currentStep === 1 ? "active" : ""}`}
                  >
                    <div className="step-number">
                      {currentStep > 1 ? (
                        <img src={success} alt="success" />
                      ) : (
                        "1"
                      )}
                    </div>
                    <div className="step-info">
                      <h5>Campaign Details</h5>
                      <p>Basic information and category</p>
                    </div>
                  </div>
                  <div
                    className={`progress-step ${currentStep >= 2 ? "completed" : ""
                      } ${currentStep === 2 ? "active" : ""}`}
                  >
                    <div className="step-number">
                      {currentStep > 2 ? (
                        <img src={success} alt="success" />
                      ) : (
                        "2"
                      )}
                    </div>
                    <div className="step-info">
                      <h5>Media & Pricing</h5>
                      <p>Images and discount setup</p>
                    </div>
                  </div>
                  <div
                    className={`progress-step ${currentStep >= 3 ? "completed" : ""
                      } ${currentStep >= 3 ? "active" : ""}`}
                  >
                    <div className="step-number">
                      {" "}
                      {currentStep > 3 ? "3" : "3"}
                    </div>
                    <div className="step-info">
                      <h5>Launch Settings</h5>
                      <p>Duration and targeting</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tips Card */}
              <div className="tips-card">
                <div className="tips-header">
                  <div className="tips-icon-badge">
                    <img src={CampaignTips} alt="Campaign Tips" />
                  </div>
                  <h4>Campaign Tips</h4>
                </div>
                <div className="tips-list">
                  <div className="tip-item blue">
                    <h5>Optimal Discount Range</h5>
                    <p className="blue-txt">
                      15-30% discounts typically generate the best response
                      rates
                    </p>
                  </div>
                  <div className="tip-item blue">
                    <h5>Image Quality</h5>
                    <p className="blue-txt">
                      Use professional photos to increase engagement by 40%
                    </p>
                  </div>
                  <div className="tip-item blue">
                    <h5>Campaign Duration</h5>
                    <p className="blue-txt">
                      14-30 day campaigns typically perform best
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddPromotion;
